import App from './App';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import 'react-toastify/dist/ReactToastify.css';
import { SidebarProvider } from './core/contexts/SidebarContext';
import { Provider } from 'react-redux';
import { store, persistor } from './store';

import { PersistGate } from 'redux-persist/integration/react';
import { normalizeUrlIfNeeded } from './core/utils/urlNormalizer';

// Optional host redirect (REACT_APP_CANONICAL_HOST: apex | www | none) so origin matches API CORS.
// If a redirect runs, the app does not render until the next load.
normalizeUrlIfNeeded();

let basename = '/';
if (process.env.PUBLIC_URL) {
  basename = process.env.PUBLIC_URL;
}

ReactDOM.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter basename={basename}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
